import { useQuery, UseQueryResult } from 'react-query';
import { IChallenge } from '../types/IChallenge';
import { getChallenges, IChallengesRequestsParams } from '../api/challenge';

interface IUseGetChallengesListResponse {
    total: number;
    entities: IChallenge[];
}

export function useGetChallengesList(params: IChallengesRequestsParams): UseQueryResult<IUseGetChallengesListResponse> {
    return useQuery(['challengesRequest', params.pageNumber, params.pageSize], () => getChallenges(params), {
        retry: false,
        staleTime: Infinity,
        cacheTime: 100,
    });
}
